<script setup lang="ts">
import { computed } from "vue";
import PublicHeader from '@/components/navigation/PublicHeader.vue';
import Footer from '@/components/layout/Footer.vue';
import { useRoute } from "vue-router";
import routeManager from "@/router/route-manager";

const route = useRoute();
const showHeaderFooter = computed<boolean>( () => !( routeManager.isSignInPath( route.path ) ) );
const isHomePage = computed<boolean>( () => routeManager.isHomePath( route.path ) );
</script>

<template>
  <div class="flex min-h-dvh flex-col">
    <PublicHeader v-if="showHeaderFooter" />

    <main :class="[ 'flex-1', isHomePage ? '' : 'm-4 gap-4' ]">
      <slot></slot>
    </main>

    <Footer v-if="showHeaderFooter" />
  </div>
</template>
